import { useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import { useDispatch } from 'react-redux';
import { getLiveTermsConditions } from '../../../store/actions/event/event-actions';
import { useTypedSelector } from '../../../store/reducers/use-typed-selector';
import { cannedTermsConditions } from '../../admin/create/homepage/editor/terms-conditions/cannedTermsConditions';
import '../../admin/create/homepage/editor/terms-conditions/terms-conditions.scss';
import WaitingIndicator from '../../general-ui/waiting-indicator/waiting-indicator';
import './terms-conditions.scss';
import classNames from 'classnames';

const TermsConditions: React.FC = () => {
	const { eventBundle, token, termsConditions } = useTypedSelector(state => ({
		eventBundle: state.LiveEventReducer.eventBundle,
		token: state.AuthReducer.token,
		termsConditions: state.LiveEventReducer.termsConditions,
	}));

	const dispatch = useDispatch();

	useEffect(() => {
		if (eventBundle?.terms_id) {
			dispatch(getLiveTermsConditions(eventBundle?.terms_id));
		}
	}, [eventBundle, token, dispatch]);

	const textOverrides = termsConditions?.settings?.content;

	return (
		<div className="terms-conditions">
			{eventBundle?.terms_id ? (
				termsConditions ? (
					<ReactMarkdown className={classNames(textOverrides?.color)} source={termsConditions.content} />
				) : (<WaitingIndicator />)
			) : (
				<ReactMarkdown source={cannedTermsConditions} />
			)}
		</div>
	);
};

export default TermsConditions;